<div class="table-header__title">
  <div class="table-header__title__label">{{ title }}</div>
  <lx-price-lists-portal-currency [currency]="currency"></lx-price-lists-portal-currency>
</div>
